import { isFolderItem, isRollupItem, isVerticalAssortmentItem } from "containers/folders/utils/space-item";

export const filterCollectionItems = (items, isVerticalAssortmentEnabled) => {
    return items.filter((item) => {
        if (isRollupItem(item.kind, item.name)) {
            return false;
        }

        if (isVerticalAssortmentEnabled) {
            return (
                isFolderItem(item.kind) || isVerticalAssortmentItem(item.kind, item?.collection_facet?.collection_type)
            );
        }

        return !isVerticalAssortmentItem(item.kind, item?.collection_facet?.collection_type);
    });
};
